module.exports = __webpack_public_path__ + "img/main-logo.4a68cc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/main-logo.svg
// module id = 73
// module chunks = 1